import { useTranslation } from "react-i18next";

// Custom switch (not Flowbite's ToggleSwitch) to match the mockup's bounce
// easing exactly, guarded for prefers-reduced-motion.
export const EnableToggle = ({ isEnabled, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isEnabled}
      aria-label={t("pages.settings.signalsPlaybooks.editor.enableSignal")}
      disabled={disabled}
      onClick={() => onChange(!isEnabled)}
      className={`relative h-[22px] w-[38px] flex-none rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-60 ${
        isEnabled ? "bg-blue-600" : "bg-gray-300"
      }`}
    >
      <span
        className={`absolute left-0.5 top-0.5 h-[18px] w-[18px] rounded-full bg-white shadow motion-safe:transition-transform motion-safe:duration-200 motion-safe:ease-[cubic-bezier(0.175,0.885,0.32,1.275)] ${
          isEnabled ? "translate-x-4" : "translate-x-0"
        }`}
      />
    </button>
  );
};
